import React from 'react';
import { Helmet } from 'react-helmet-async';
import Evaluations from './Evaluations';
import useRouter from '../../hooks/useRouter';
import PageHeading from '../../@communityshare/ui/PageHeading';
import Results from '../_common_results/Results';
import EvaluationProjectPartnerComplete from '../evaluations-project-partners-filtered/complete/Evaluation';
import EvaluationProjectPartnerPending from '../evaluations-project-partners-filtered/pending/Evaluation';
import { ClipboardDocumentListIcon } from '@heroicons/react/24/outline';
import MobileNavigation from '../evaluations/MobileNavigation';

export default function Layout(props) {
  const router = useRouter();

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>Explore Projects</title>
      </Helmet>
      <MobileNavigation />
      <PageHeading
        breadcrumbs={['Evaluations', 'Projects: Partners']}
        title="All Evaluations"
        description={(
          <>
            Project evaluations sent to a partner.
          </>
        )}
      />
      <Evaluations router={router}>
        {function(result) {
          return (
            <Results result={result} columns={1} resource="evaluations" emptyIcon={ClipboardDocumentListIcon}>
              {function(evaluationProjectPartner) {
                if (evaluationProjectPartner.data.completed) {
                  return (
                    <EvaluationProjectPartnerComplete
                      key={evaluationProjectPartner.id}
                      evaluation={evaluationProjectPartner}
                    />
                  );
                }

                return (
                  <EvaluationProjectPartnerPending
                    key={evaluationProjectPartner.id}
                    evaluation={evaluationProjectPartner}
                  />
                );
              }}
            </Results>
          );
        }}
      </Evaluations>
    </div>
  );
}
